import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NEWS_TYPES, NewsItem, NewsType } from '../../../model/v3/news';
import { AdminNewsV3RestService } from '../../../services/rest/v3/admin-news-rest.service';
import { Page, Pageable } from '../../../model/rest/base';
import { ModalComponent } from '../../../components/modal/modal.component';

@Component({
  selector: 'app-admin-news-page',
  templateUrl: './admin-news-page.component.html',
  styleUrls: ['./admin-news-page.component.scss'],
  standalone: false,
})
export class AdminNewsPageComponent implements OnInit {
  @ViewChild('deleteConfirmModal') deleteConfirmModal: ModalComponent;
  readonly newsTypes = NEWS_TYPES;
  searchTerm = '';
  typeFilter: NewsType | null = null;
  items: NewsItem[] = [];
  newsPage: Page<NewsItem>;
  pageable = new Pageable(0, 20, ['publicationDate,DESC']);
  itemToDelete: NewsItem | null = null;
  deleting = false;

  constructor(
    private router: Router,
    private adminNewsRest: AdminNewsV3RestService,
  ) {}

  ngOnInit(): void {
    this.loadNews();
  }

  loadNews(): void {
    this.adminNewsRest.listNews(this.searchTerm, this.typeFilter, this.pageable).subscribe((page) => {
      this.newsPage = page;
      this.items = page?.content ?? [];
    });
  }

  searchUpdated(): void {
    this.pageable.page = 0;
    this.loadNews();
  }

  typeFilterUpdated(): void {
    this.pageable.page = 0;
    this.loadNews();
  }

  switchPage($event: Pageable): void {
    this.pageable = $event;
    this.loadNews();
  }

  createNews(): void {
    this.router.navigate(['/admin/news/new']).then();
  }

  editNews(item: NewsItem): void {
    this.router.navigate(['/admin/news', item.id, 'edit']).then();
  }

  openNews(item: NewsItem): void {
    this.router.navigate(['/admin/news', item.id]).then();
  }

  requestDeleteNews(item: NewsItem): void {
    this.itemToDelete = item;
    this.deleteConfirmModal?.show();
  }

  deleteNews(): void {
    if (!this.itemToDelete?.id || this.deleting) {
      return;
    }
    this.deleting = true;
    this.adminNewsRest.deleteNews(this.itemToDelete.id).subscribe(() => {
      this.deleting = false;
      this.deleteConfirmModal?.hide();
      this.itemToDelete = null;
      this.loadNews();
    }, () => {
      this.deleting = false;
    });
  }
}
